import styled from 'styled-components';

import SideNavLink from '../SideNavLink';

export const StyledNav = styled.nav`
  position: relative;
`;

export const StyledList = styled.ol<{ bottomBorder: string }>`
  margin: 0;
  padding: 0;
  border-bottom: ${({ bottomBorder }) => bottomBorder || '1px solid white'};
`;

export const StyledListItem = styled.li`
  margin: 0;
  list-style: none;

  &:last-child ${SideNavLink.StyledLink} {
    border-bottom-width: 0px;
  }
`;
